import {dashboardTabId, dashboardViews} from '../../../../../../../util/uiconstants';
import {currentResource} from '../../../../../../../util/utils';

import getAvailableEntityList, {
	getAdminAvailableEntityList,
	getEntityIndeterminateState
} from '../../../DefineAccessPanel/utils/getAvailableEntityList';
import {getFlattenContacts, getUniqueContacts} from '../../../GenerateMessage/GMForm/utils/normalizeFilters';

export const getAdminViews = (filteredEntities, userGui) => {
	const adminObj = filteredEntities[0]?.entityAdmins?.find(({userId}) => userId === userGui);
	return adminObj?.views || [];
};

export default ({entities, selected, isProjectOwner, orgChart, userGui, constants, selectedIsProjectOwner, selectedIsEntityAdmin}) => {
	const {
		USER_LIST,
		HAS_EXTERNAL,
		ENTITIES,
		DASHBOARD_VIEWS,
		ACCESS_TO_DASHBOARD,
		ACCESS_TO_CONTACT_LIST,
		ACCESS_TO_GROUP_RISK_ASSESMENT,
		PROJECT_OWNER_ACCESS,
		ENTITY_ADMIN_ACCESS
	} = constants;

	let hasExternal = false,
		accessToDashboard = 0,
		milestones = 0,
		eyccp = 0,
		gaudit = 0,
		pmanagement = 0,
		gRiskAssesment = 0,
		insights = 0,
		reporting = 0,
		accessToContactList = 0;
	let accessToGroupRiskAssessment = 0;

	const normalizeNodes = (node) =>
		node.map((entity) => {
			let newContacts = [...entity.contacts];
			if (entities.some(({entityId}) => entityId === entity.entityId)) {
				newContacts = [...entities.find(({entityId}) => entityId === entity.entityId)?.contacts];
			}
			const newNodes = entity?.nodes?.length > 0 ? normalizeNodes(entity.nodes) : [];
			return {...entity, contacts: newContacts, nodes: newNodes};
		});

	const newOrgChart = normalizeNodes(orgChart);

	const filteredEntities = isProjectOwner
		? getAvailableEntityList(newOrgChart)
		: getAdminAvailableEntityList(newOrgChart, userGui);

	const uniqueContactsWithProps = getUniqueContacts(getFlattenContacts(entities)).filter(
		({userId, isInternal, dashboard, contactList, hasAccess, groupRiskAssessment}) => {
			if (selected.includes(userId)) {
				if (!isInternal) hasExternal = true;
				if (dashboard.length > 0) accessToDashboard += 1;
				if (contactList?.hasAccess || hasAccess) accessToContactList += 1;
				if (groupRiskAssessment?.hasAccess) accessToGroupRiskAssessment += 1;

				if (dashboard.includes(dashboardViews.milestones) || dashboard.includes(dashboardViews.all)) milestones += 1;
				if (dashboard.includes(dashboardViews.projectManagement) || dashboard.includes(dashboardViews.all)) pmanagement += 1;
				if (dashboard.includes(dashboardViews.groupAudit) || dashboard.includes(dashboardViews.all)) gaudit += 1;
				if (dashboard.includes(dashboardViews.groupRiskAssessment) || dashboard.includes(dashboardViews.all)) gRiskAssesment += 1;
				if (dashboard.includes(dashboardViews.insights) || dashboard.includes(dashboardViews.all)) insights += 1;
				if (dashboard.includes(dashboardViews.reporting) || dashboard.includes(dashboardViews.all)) reporting += 1;
				if (dashboard.includes(dashboardViews.ccp) || dashboard.includes(dashboardViews.all)) eyccp += 1;

				return true;
			}
			return false;
		}
	);

	const getDashboardAccess = () => {
		if (accessToDashboard === 0) return false;
		if (accessToDashboard === uniqueContactsWithProps.length) return true;
		return null;
	};

	const getContactListAccess = () => {
		if (accessToContactList === 0) return false;
		if (accessToContactList === uniqueContactsWithProps.length) return true;
		return null;
	};

	const getGroupRiskAssessmentAccess = () => {
		if (accessToGroupRiskAssessment === 0) return false;
		if (accessToGroupRiskAssessment === uniqueContactsWithProps.length) return true;
		return null;
	};

	const getDashboardViewObject = () =>
		Object.values(dashboardTabId).map((id) => {
			let disabled = false,
				checked = false,
				indeterminate = false;

			const {key: label, tooltipText: tooltip, value: key} = currentResource?.dashboardContactViews.find(
				(x) => x.id === id
			);
			if (!isProjectOwner) {
				const adminViews = getAdminViews(filteredEntities, userGui);
				if (!(adminViews.includes(key) || adminViews.includes(dashboardViews.all))) disabled = true;
			}

			if (key === dashboardViews.milestones) {
				if (milestones !== 0) {
					checked = true;
					if (selected.length > milestones) indeterminate = true;
				}
			}

			if (key === dashboardViews.ccp) {
				if (eyccp !== 0) {
					checked = true;
					if (selected.length > eyccp) indeterminate = true;
				}
			}

			if (key === dashboardViews.groupAudit) {
				if (gaudit !== 0) {
					checked = true;
					if (selected.length > gaudit) indeterminate = true;
				}
			}

			if (key === dashboardViews.projectManagement) {
				if (pmanagement !== 0) {
					checked = true;
					if (selected.length > pmanagement) indeterminate = true;
				}
				if (hasExternal) disabled = true;
			}

			if (key === dashboardViews.insights) {
				if (insights !== 0) {
					checked = true;
					if (selected.length > insights) indeterminate = true;
				}
				if (hasExternal) disabled = true;
			}

			if (key === dashboardViews.reporting) {
				if (reporting !== 0) {
					checked = true;
					if (selected.length > reporting) indeterminate = true;
				}
			}

			return {id, label, tooltip, key, disabled, checked, indeterminate};
		});

	return {
		[USER_LIST]: uniqueContactsWithProps,
		[HAS_EXTERNAL]: hasExternal,
		[ENTITIES]: getEntityIndeterminateState(filteredEntities, uniqueContactsWithProps),
		[ACCESS_TO_DASHBOARD]: getDashboardAccess(),
		[DASHBOARD_VIEWS]: getDashboardViewObject(),
		[ACCESS_TO_CONTACT_LIST]: getContactListAccess(),
		[ACCESS_TO_GROUP_RISK_ASSESMENT]: getGroupRiskAssessmentAccess(),
		[PROJECT_OWNER_ACCESS]: selectedIsProjectOwner,
		[ENTITY_ADMIN_ACCESS]: selectedIsEntityAdmin
	};
};
